import { render, staticRenderFns } from "./DropdownMenu.component.vue?vue&type=template&id=0a681335&"
import script from "./DropdownMenu.component.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenu.component.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenu.component.vue?vue&type=style&index=0&id=0a681335&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports